import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import RLTraining from '../components/rl/RLTraining';

function TrainingPage() {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          🎯 RL Training Center
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Train and optimize your reinforcement learning agents
        </Typography>
      </Box>

      <RLTraining />
    </Container>
  );
}

export default TrainingPage;